<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />


<div class="container-fluid gx-5">
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;" class="page-header">
          <fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'gears']"></fa-icon> Manage Control Parameters
        </h3>
      </div>
      <form [formGroup]="form" class="k-form-inline">

        <div class="k-form-field">
          <label for="param_product_name" class="form-label col-3">Product Name</label>
          <div class="col-8">
            <input appAutoFocus type="text" id="param_product_name" formControlName="param_product_name"
              class="form-control">
          </div>
        </div>

        <div class="k-form-field">
          <label for="param_company_name" class="form-label col-3">Company Name</label>
          <div class="col-8">
            <input type="text" id="param_company_name" formControlName="param_company_name" class="form-control">
          </div>
        </div>

        <div class="k-form-field">
          <label for="param_entity_name" class="form-label col-3">Controlling Entity Name</label>
          <div class="col-8">
            <input type="text" id="param_entity_name" formControlName="param_entity_name" class="form-control">
          </div>
        </div>

        <div class="k-form-field">
          <label for="param_company_address" class="form-label col-3">Address</label>
          <div class="col-8">
            <textarea rows="5" id="param_company_address" formControlName="param_company_address" class="form-control">
            </textarea>
          </div>
        </div>

        <div class="k-form-field">
          <label for="param_abn" class="form-label col-3">ABN</label>
          <div class="col-8">
            <input type="text" id="param_abn" formControlName="param_abn" class="form-control">
          </div>
        </div>

        <div class="k-form-field">
          <label for="param_acn" class="form-label col-3">ACN</label>
          <div class="col-8">
            <input type="text" id="param_acn" formControlName="param_acn" class="form-control">
          </div>
        </div>

        <div class="k-form-field">
          <label for="param_website_url" class="form-label col-3">Website URL</label>
          <div class="col-8">
            <input type="text" id="param_website_url" formControlName="param_website_url" class="form-control">
          </div>
        </div>

        <div class="k-form-field">
          <label for="app_base_url" class="form-label col-3">Application Base URL</label>
          <div class="col-8">
            <input type="text" id="app_base_url" formControlName="app_base_url" class="form-control">
          </div>
        </div>

        <div class="k-form-field">
          <label for="param_primary_contact_number" class="form-label col-3">Phone 1: Primary Office Number</label>
          <div class="col-8">
            <input type="text" id="param_primary_contact_number" formControlName="param_primary_contact_number"
              class="form-control">
            <div *ngIf="param_primary_contact_number?.invalid" class="alert alert-danger">
              <div *ngIf="param_primary_contact_number?.errors?.['pattern']">Invalid Phone Number.</div>
            </div>
          </div>
        </div>

        <div class="k-form-field">
          <label for="param_additional_contact_number" class="form-label col-3">Phone 2: Additional Contact
            Number</label>
          <div class="col-8">
            <input type="text" id="param_additional_contact_number" formControlName="param_additional_contact_number"
              class="form-control">
            <div *ngIf="param_additional_contact_number?.invalid" class="alert alert-danger">
              <div *ngIf="param_additional_contact_number?.errors?.['pattern']">Invalid Phone Number.</div>
            </div>
          </div>
        </div>

        <div class="k-form-field">
          <label for="param_primary_email" class="form-label col-3 k-label">Primary Contact Email (from)</label>
          <div class="col-8">
            <input type="param_primary_email" id="param_primary_email" formControlName="param_primary_email"
              class="form-control">
            <div *ngIf="param_primary_email?.invalid && (param_primary_email?.dirty || param_primary_email?.touched)"
              class="alert alert-danger">
              <div *ngIf="param_primary_email?.errors && param_primary_email?.errors?.['email']">Please enter a valid
                contact email
                address.</div>
            </div>
          </div>
        </div>

        <div class="k-form-field">
          <label for="param_additional_email" class="form-label col-3 k-label">Additional Inquiries Email
            Address</label>
          <div class="col-8">
            <input type="param_additional_email" id="param_additional_email" formControlName="param_additional_email"
              class="form-control">
            <div
              *ngIf="param_additional_email?.invalid && (param_additional_email?.dirty || param_additional_email?.touched)"
              class="alert alert-danger">
              <div *ngIf="param_additional_email?.errors && param_additional_email?.errors?.['email']">Please enter a
                valid contact email
                address.</div>
            </div>
          </div>
        </div>

        <div class="k-form-field">
          <label for="param_reply_to_email" class="form-label col-3 k-label">Customer Reply To Email Address</label>
          <div class="col-8">
            <input type="param_reply_to_email" id="param_reply_to_email" formControlName="param_reply_to_email"
              class="form-control">
            <div *ngIf="param_reply_to_email?.invalid && (param_reply_to_email?.dirty || param_reply_to_email?.touched)"
              class="alert alert-danger">
              <div *ngIf="param_reply_to_email?.errors && param_reply_to_email?.errors?.['email']">Please enter a valid
                contact email
                address.</div>
            </div>
          </div>
        </div>

        <div class="k-form-field">
          <label for="param_reset_password_bcc" class="form-label col-3 k-label">Reset Password - Email Copy
            (bcc)</label>
          <div class="col-8">
            <input type="param_reset_password_bcc" id="param_reset_password_bcc"
              formControlName="param_reset_password_bcc" class="form-control">
            <div
              *ngIf="param_reset_password_bcc?.invalid && (param_reset_password_bcc?.dirty || param_reset_password_bcc?.touched)"
              class="alert alert-danger">
              <div *ngIf="param_reset_password_bcc?.errors && param_reset_password_bcc?.errors?.['email']">Please enter
                a valid contact email
                address.</div>
            </div>
          </div>
        </div>

        <div class="k-form-field">
          <label for="param_primary_image" class="form-label col-3">Business Logo Image</label>
          <div class="col-4">
            <kendo-upload id="param_primary_image" name="param_primary_image" [autoUpload]="false"
              [saveUrl]="uploadSaveUrlBusiness" [removeUrl]="uploadRemoveUrl" [restrictions]="myRestrictions"
              (cancel)="cancel($event)" (clear)="clear()" (complete)="complete()" (error)="error($event)"
              (blur)="blur()" (focus)="focus()" (pause)="pause($event)" (remove)="remove($event)"
              (resume)="resume($event)" (select)="select($event)" (success)="success($event)" (upload)="upload($event)"
              (uploadProgress)="uploadProgress($event)" (valueChange)="valueChange($event)">
            </kendo-upload>
          </div>
          <div class="col-1">
            @if(hasBusinessLogo) {
            <div kendoTooltip style="text-align: center; padding-top: 10px;">
              <button kendoButton title="Clear Business Logo" class="btn btn-lg"
                (click)="clearLogo('business')"><fa-icon class="fa-solid fa-duotone"
                  [icon]="['fad', 'ban']"></fa-icon></button>

            </div>
            }
          </div>

          <div class="col-3">
            @if(hasBusinessLogo) {
            <img id="businessLogoImage" src="data:image/JPEG;base64,{{logoBusiness}}"
              style="max-width: 100%; max-height: 100px;" />
            } @else {
            <img id="businessLogoImage2" style="max-width: 100%; max-height: 100px;" />
            }
          </div>

        </div>

        <div class="k-form-field">
          <label for="param_additional_image" class="form-label col-3">Product Logo Image</label>
          <div class="col-4">
            <kendo-upload id="param_additional_image" name="param_additional_image" [autoUpload]="false"
              [saveUrl]="uploadSaveUrlProduct" [removeUrl]="uploadRemoveUrl" [restrictions]="myRestrictions"
              (cancel)="cancelProduct($event)" (clear)="clearProduct()" (complete)="completeProduct()"
              (error)="errorProduct($event)" (blur)="blurProduct()" (focus)="focusProduct()"
              (pause)="pauseProduct($event)" (remove)="removeProduct($event)" (resume)="resumeProduct($event)"
              (select)="selectProduct($event)" (success)="successProduct($event)" (upload)="uploadProduct($event)"
              (uploadProgress)="uploadProgressProduct($event)" (valueChange)="valueChangeProduct($event)">
            </kendo-upload>
          </div>
          <div class="col-1">
            @if(hasProductLogo) {
            <div kendoTooltip style="text-align: center; padding-top: 10px;">
              <button kendoButton title="Clear Product Logo" class="btn btn-lg" (click)="clearLogo('product')"><fa-icon
                  class="fa-solid fa-duotone" [icon]="['fad', 'ban']"></fa-icon></button>
            </div>
            }
          </div>

          <div class="col-3">
            @if(hasProductLogo) {
            <img id="additionalLogoImage" src="data:image/JPEG;base64,{{logoProduct}}"
              style="max-width: 100%; max-height: 100px;" />
            } @else {
            <img id="additionalLogoImage2" style="max-width: 100%; max-height: 100px;" />
            }
          </div>

        </div>

        <div class="d-grid d-md-flex justify-content-md-end">
          @if(this.canUpdate){
          <button type="button" class="btn btn-primary me-md-2" (click)="onSubmit()"
            [disabled]="form.invalid || form.pristine">Save</button>
          }
          <button type="button" class="btn btn-secondary" (click)="cancelChanges()"> Cancel</button>
        </div>

      </form>

    </div>
  </div>

</div>
